<template>
  <Modal v-model="state" :title="plustitle" :mask-closable="false" width="600" class-name="c-ads-edit vertical-center-modal">
    <div class="ads-edif-form">
      <Form ref="adsEditForm" :model="adsData" :rules="ruleValidate" :label-width="160">
        <FormItem label="投放位ID" prop="advertPosiId" v-if="editFlag === 'edit'">
          <Input v-model="adsData.advertPosiId" width="200" style="width: 320px" :disabled="true" />
        </FormItem>
        <FormItem label="媒体名称" prop="mediaId" v-if="editFlag === 'add'">
          <el-select
            v-model="adsData.mediaId"
            :popper-append-to-body="false"
            placeholder="请选择媒体"
            style="width: 150px"
            size="small"
            clearable
            collapse-tags
            filterable
          >
            <el-option v-for="item in mediaData" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </FormItem>
        <FormItem label="媒体名称" prop="mediaName" v-if="editFlag === 'edit'">
          <Input v-model="adsData.mediaName" width="200" style="width: 320px" disabled />
        </FormItem>
        <FormItem label="投放位名称" prop="advertPosiName">
          <Input v-model="adsData.advertPosiName" placeholder="请输入投放位名称" :maxlength="50" style="width: 320px" width="200" />
        </FormItem>
        <FormItem label="语法位媒体API编码" prop="advertPosiDesc">
          <Input
            v-model="adsData.advertPosiDesc"
            placeholder="请输入投放位媒体API编码"
            :maxlength="100"
            style="width: 320px"
            width="200"
          /><br />
          <span class="c-notify-text">注意：投放位媒体API编码用于媒体的API做映射使用，不清楚请勿填写</span>
        </FormItem>
      </Form>
    </div>
    <template slot="footer">
      <div class="m-foot">
        <Poptip
          title="删除媒体投放位将不可以恢复，相应绑定的数据报表将丢失，您确认是否继续？"
          style="float: left"
          ok-text="继续删除"
          width="300"
          confirm
          transfer
          @on-ok="delAdv()"
          v-if="editFlag === 'edit'"
        >
          <Button type="error" :loading="loading" class="c-delete-btn">
            <span v-if="loading">提交中...</span>
            <span v-else>删除投放位</span>
          </Button>
        </Poptip>
        <Button @click="$emit('input', false)">取消</Button>
        <Button type="primary" :loading="loading" @click="saveAdv">
          <span v-if="loading">提交中...</span>
          <span v-else>确认</span>
        </Button>
      </div>
    </template>
  </Modal>
</template>

<script>
export default {
  name: 'adsEdit',
  props: {
    value: {
      type: Boolean
    },
    title: {
      type: String
    },
    loading: {
      type: Boolean,
      default() {
        return false
      }
    },
    mediaData: {
      type: Array
    },
    editData: {
      type: Object
    },
    editFlag: {
      type: String
    }
  },
  data() {
    var requiredMediaId = () => {
      return this.editFlag === 'add'
    }
    var checkAdvertPosiName = (rule, value, callback) => {
      if (!value || value.trim() === '') {
        return callback(new Error('媒体投放位名称不能为空'))
      }
      return callback()
    }
    var checkMediaId = (rule, value, callback) => {
      if (this.editFlag === 'add') {
        if (!this.adsData.mediaId) {
          return callback(new Error('媒体不能为空'))
        }
      }
      return callback()
    }
    return {
      adsData: {
        mediaId: null,
        mediaName: '',
        advertPosiId: null,
        advertPosiName: '',
        advertPosiDesc: ''
      },
      ruleValidate: {
        mediaId: [{ required: requiredMediaId, validator: checkMediaId, trigger: 'blur' }],
        advertPosiName: [{ required: true, validator: checkAdvertPosiName, trigger: 'blur' }]
      }
    }
  },
  computed: {
    state: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    plustitle() {
      return `${this.editFlag === 'edit' ? '修改' : '新建'}${this.title}`
    }
  },
  watch: {
    editData: {
      handler(nVal) {
        this.updateInfo()
      },
      deep: true
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.updateInfo()
    })
  },
  methods: {
    updateInfo() {
      this.$refs.adsEditForm.resetFields()
      const info = JSON.parse(JSON.stringify(this.editData))
      this.adsData.mediaId = info.mediaId
      this.adsData.mediaName = info.mediaName
      this.adsData.advertPosiId = info.advertPosiId
      this.adsData.advertPosiName = info.advertPosiName
      this.adsData.advertPosiDesc = info.advertPosiDesc
    },
    saveAdv() {
      this.$refs.adsEditForm.validate((valid) => {
        if (valid) {
          this.$emit('on-save', this.adsData)
        } else {
          this.$Message.error('表单验证失败!')
        }
      })
    },
    delAdv() {
      const params = {
        advertPosiId: this.adsData.advertPosiId
      }
      this.$emit('on-del', params)
    }
  }
}
</script>
<style lang="scss" scoped>
.c-ads-edit {
  position: relative;

  .media-edif-form {
    overflow-y: auto;
    scrollbar-width: thin;
    -webkit-overflow-scrolling: touch;
    max-height: 480px;

    ::v-deep .el-input__inner {
      height: 32px;
    }

    ::v-deep .el-input__icon {
      line-height: 30px;
      width: 20px;
    }
  }

  .ivu-input-wrapper::v-deep .ivu-input {
    font-size: 12px;
  }

  .c-notify-text {
    margin-top: 8px;
    width: 320px;
    color: #ff6400;
    word-break: normal;
    white-space: pre-wrap;
    word-wrap: break-word;
    display: block;
    line-height: 16px;
  }

  .c-delete-btn {
    color: #ee4013;
    background-color: #fff;
  }
}
</style>
